export default function extractFileExtensionFromUrl(filePath: string): string {
	if (filePath) {
		const pathname = new URL(filePath).pathname;
		const index = pathname.lastIndexOf('/');
		const file = pathname.substring(index + 1);
		const fileNameWithId = file.substring(file.indexOf('.') + 1);
		const fileExtension = fileNameWithId.substring(fileNameWithId.indexOf('.') + 1);
		return fileExtension;
	}
	return filePath;
}
